import React, { Component } from 'react';
import { connect } from 'react-redux';
import Link from '../../Link/Link';
import Arrow from '../../Icons/Arrow';
import { css } from '@emotion/core';
import { GrFormClose } from 'react-icons/gr';
import LoginIcon from '../../Icons/Login';
import { FiMenu } from 'react-icons/fi';
import { primary_dark15, primary_light } from '../../lib/colors';

class Modal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      top: null,
      left: null,
      activeCategoryIndex: null,
      activeSubcategoryIndex: null,
    };
    this.handleCategoryClick = this.handleCategoryClick.bind(this);
    this.handleSubCategoryClick = this.handleSubCategoryClick.bind(this);
  }

  toggleModal = () => {
    this.setState({
      showModal: !this.state.showModal,
      activeCategoryIndex: null,
      activeSubcategoryIndex: null,
    });
  };

  calculatePosition = () => {
    const { referenceElement } = this.props;
    const referenceRect = referenceElement.getBoundingClientRect();
    const modalRect = this.modalElement.getBoundingClientRect();

    const top = referenceRect.bottom + 10;
    const left =
      referenceRect.left + referenceRect.width / 2 - modalRect.width / 2;

    this.setState({
      top,
      left,
    });
  };

  componentDidMount() {
    if (this.state.showModal) {
      document.body.style.overflow = 'hidden';
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.referenceElement !== this.props.referenceElement) {
      this.calculatePosition();
    }
    if (prevState.showModal !== this.state.showModal) {
      document.body.style.overflow = this.state.showModal ? 'hidden' : 'auto';
    }
  }

  handleCategoryClick = index => {
    this.setState({
      activeCategoryIndex: index,
      activeSubcategoryIndex: null,
    });
  };

  handleSubCategoryClick = index => {
    this.setState({
      activeSubcategoryIndex: index,
    });
  };

  renderCategories = categoryTags => {
    const { activeCategoryIndex } = this.state;
    const { primaryColor } = this.props;
    return (
      <div className="subcategories">
        {categoryTags.map((category, index) => (
          <li
            key={index}
            onClick={() => this.handleCategoryClick(index)}
            className={activeCategoryIndex === index ? 'active' : ''}
          >
            <Link>
              {category.name}
              <Arrow />
            </Link>
          </li>
        ))}
        <div
          style={{ borderTop: '1px solid #CCC', marginTop: 8, paddingTop: 8 }}
        >
          {!!this.props.discounted.length && (
            <li>
              <Link
                to="/prodotti-in-offerta"
                onClick={() => {
                  this.toggleModal();
                }}
              >
                Offerte
                <Arrow />
              </Link>
            </li>
          )}
          {!!this.props.hasBlog && (
            <li>
              <Link
                to="/blog"
                onClick={() => {
                  this.toggleModal();
                }}
              >
                Blog
                <Arrow />
              </Link>
            </li>
          )}
          {!!this.props.hasBlog && !!this.props.couponPageUrl && (
            <li>
              <Link
                to={this.props.couponPageUrl}
                onClick={() => {
                  this.toggleModal();
                }}
              >
                Coupon
                <Arrow />
              </Link>
            </li>
          )}
          <li>
            <Link
              to="/pagine/contattaci"
              onClick={() => {
                this.toggleModal();
              }}
            >
              Contatti
              <Arrow />
            </Link>
          </li>
        </div>
      </div>
    );
  };

  renderCategoriesMobile(categoryTags) {
    const { activeCategoryIndex } = this.state;

    return categoryTags.map((category, index) => (
      <li
        key={index}
        onClick={() => this.handleCategoryClick(index)}
        className={activeCategoryIndex === index ? 'active' : ''}
      >
        <Link
          to={'/tag-categoria/' + category.name}
          onClick={() => {
            this.toggleModal();
          }}
        >
          {category.name}
        </Link>
      </li>
    ));
  }

  renderSubcategories(categoryTags) {
    const { primaryColor } = this.props;
    const { activeCategoryIndex, activeSubcategoryIndex } = this.state;
    const activeCategory = categoryTags[activeCategoryIndex];

    if (activeCategoryIndex !== null) {
      return (
        <div className="subcategories">
          {activeCategory.categories.map((subcategory, index) =>
            !subcategory.subcategories.length ? (
              <li>
                <Link
                  to={`/${subcategory.type}/${subcategory.parentSeoName}/${subcategory.seoName}`}
                  onClick={() => {
                    this.toggleModal();
                  }}
                >
                  {subcategory.name}
                </Link>
              </li>
            ) : (
              <li
                key={index}
                onClick={() => this.handleSubCategoryClick(index)}
                className={
                  activeSubcategoryIndex === index
                    ? 'active'
                    : 'subcategories-item'
                }
              >
                <Link>
                  {subcategory.name}
                  <Arrow />
                </Link>
              </li>
            )
          )}
          {!activeCategory.hideViewAllLink &&
            activeCategory.categories.length > 1 && (
              <li>
                <Link
                  to={'/tag-categoria/' + activeCategory.name}
                  className={'subcategories-item'}
                  style={{ color: primaryColor }}
                  onClick={() => {
                    this.toggleModal();
                  }}
                >
                  Vedi tutti in {activeCategory.name}
                </Link>
              </li>
            )}
        </div>
      );
    } else {
      return null;
    }
  }

  renderSubSubcategories = categoryTags => {
    const { primaryColor } = this.props;
    const { activeCategoryIndex, activeSubcategoryIndex } = this.state;

    if (activeSubcategoryIndex !== null) {
      const activeCategory = categoryTags[activeCategoryIndex];
      const activeSubcategory =
        activeCategory.categories[activeSubcategoryIndex];
      return (
        <div className="subsubcategories">
          {activeSubcategory.subcategories.map((subsubcategory, index) => (
            <div key={index}>
              <li>
                <Link
                  to={`/${activeSubcategory.type}/${activeSubcategory.seoName}/${subsubcategory.seoName}`}
                  onClick={() => {
                    this.toggleModal();
                  }}
                >
                  {subsubcategory.name}
                </Link>
              </li>
            </div>
          ))}
          <li>
            <Link
              to={`/${activeSubcategory.type}/${activeSubcategory.seoName}`}
              style={{ color: primaryColor }}
              onClick={() => {
                this.toggleModal();
              }}
            >
              Vedi tutti in {activeSubcategory.name}
            </Link>
          </li>
        </div>
      );
    } else {
      return null;
    }
  };

  render() {
    const {
      categoryTags,
      primaryColor,
      categories,
      isAuthenticated,
      user,
    } = this.props;
    const {
      top,
      left,
      showModal,
      activeCategoryIndex,
      activeSubcategoryIndex,
    } = this.state;

    const subsubcategoriesMenuStyle = css`
      & .column-categories.third::-webkit-scrollbar-thumb {
        background-color: ${primaryColor};
      }
      & .column-categories {
        li:hover {
          background-color: ${primary_light(primaryColor)};
        }
      }
    `;

    const productsCategories = categories.filter(
      category => category.type === 'prodotti'
    );
    const farmaciCategories = categories.filter(
      category => category.type === 'farmaci'
    );

    const tagCategoriesToShow = [
      ...(categoryTags || []),
      productsCategories.length
        ? {
            name: 'Prodotti',
            visible: 1,
            categories: productsCategories,
            hideViewAllLink: true,
          }
        : null,
      farmaciCategories.length
        ? {
            name: 'Farmaci',
            visible: 1,
            categories: farmaciCategories,
            hideViewAllLink: true,
          }
        : null,
    ].filter(tag => !!tag);

    return (
      <div className="modal-container">
        <div className="categories-menu" onClick={this.toggleModal}>
          <FiMenu />
          <span>Menu</span>
        </div>
        {showModal && (
          <div>
            <div className="backdrop" onClick={this.toggleModal}></div>
            <div
              className="modal"
              style={{
                top,
                left,
                width:
                  activeCategoryIndex === null
                    ? '23vw'
                    : activeSubcategoryIndex !== null
                    ? '69vw'
                    : '46vw',
                transition: 'width 0.5s ease',
              }}
              ref={el => (this.modalElement = el)}
            >
              <div className="modal-content">
                <div className="modal-title">
                  <h5>Scegli per categoria</h5>
                  <div onClick={this.toggleModal}>
                    <GrFormClose />
                  </div>
                </div>
                <div
                  className="modal-body-desktop"
                  css={subsubcategoriesMenuStyle}
                >
                  <div className="column-categories first">
                    {this.renderCategories(tagCategoriesToShow)}
                  </div>
                  <div className="column-categories second">
                    {this.renderSubcategories(tagCategoriesToShow)}
                  </div>
                  <div className="column-categories third">
                    {this.renderSubSubcategories(tagCategoriesToShow)}
                  </div>
                </div>
                <div
                  className="modal-body-mobile"
                  css={subsubcategoriesMenuStyle}
                >
                  <div className="column-categories first">
                    {this.renderCategoriesMobile(tagCategoriesToShow)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    categoryTags: state.categories.data.tags,
    primaryColor: state.store.data.loghiTemplate.brandColor,
    secondaryColor: state.store.data.loghiTemplate.secondaryColor,
    user: state.user.data,
    isAuthenticated: state.user.authenticated,
    categories: state.categories.data.categories,
    discounted: state.homeProducts.data.discounted,
    hasBlog: state.store.data.features.hasBlog,
    couponPageUrl: state.store.data.funzionalita.couponPageUrl,
  };
}

export default connect(mapStateToProps)(Modal);
